import React from 'react';
import { Avatar, Stack, Text } from '@chakra-ui/react';

type Props = {
  name: string;
  email: string;
  imgUrl: string | undefined;
};

const UserCard = ({ name, email, imgUrl }: Props): React.ReactElement => (
  <Stack direction='row' spacing={4} align='center' p='16px'>
    <Avatar name={name} src={imgUrl} />
    <Stack direction='column' spacing={0} fontSize='sm'>
      <Text fontWeight={600}>{name}</Text>
      <Text color='gray.500'>{email}</Text>
    </Stack>
  </Stack>
);

export default UserCard;
